import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requestConfig from 'app/requests/Logger.requests'
import simpleApi from 'app/services/simpleApi'

const useAddLoggerDocument = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onError,
    } = useHandleStatusRequest({
        id: 'Add Document',
    })

    return useMutation({
        mutationFn: ({
            loggerId,
            data,
        }: {
            loggerId: number,
            data: {
                document:{
                    id: number,
                },
                calibratedOn: string,
            }
        }) => {
            return simpleApi({
                ...requestConfig.addDocument({
                    loggerId, data,
                }),
                token,
            })
        },
        onSuccess,
        onError,
    })
}

export default useAddLoggerDocument
